import { render, staticRenderFns } from "./taxNo.vue?vue&type=template&id=6487311c&scoped=true&"
import script from "./taxNo.vue?vue&type=script&lang=js&"
export * from "./taxNo.vue?vue&type=script&lang=js&"
import style0 from "./taxNo.vue?vue&type=style&index=0&id=6487311c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6487311c",
  null
  
)

export default component.exports